import { useEffect, useRef } from 'react';
import { t } from '../../i18n/I18n';

/** Opt-in development measurements, visible in the page for browser verification. No production work. */
export const presencePerformance = {
  enabled: !!import.meta.env?.DEV && typeof location !== 'undefined' && new URLSearchParams(location.search).has('presencePerf'),
  costs: [] as number[], commits: 0,
};
export function PresencePerformance() {
  const output = useRef<HTMLOutputElement>(null);
  useEffect(() => {
    if (!presencePerformance.enabled) return;
    let frame = 0, last = performance.now(), reported = last;
    const intervals: number[] = [];
    const percentile = (values: number[]) => values.length ? [...values].sort((a, b) => a - b)[Math.floor((values.length - 1) * .95)] : 0;
    const step = (now: number) => {
      if (!document.hidden) intervals.push(now - last);
      last = now;
      if (now - reported >= 1000 && output.current) {
        const costs = presencePerformance.costs.splice(0), commits = presencePerformance.commits;
        presencePerformance.commits = 0;
        const mean = intervals.reduce((a, b) => a + b, 0) / Math.max(1, intervals.length);
        output.current.textContent = t('#CollabPerfReadout', String(Math.round(1000 / mean)), percentile(intervals).toFixed(1), percentile(costs).toFixed(2), String(commits));
        output.current.dataset.samples = String(intervals.length);
        intervals.length = 0; reported = now;
      }
      frame = requestAnimationFrame(step);
    };
    frame = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frame);
  }, []);
  return presencePerformance.enabled ? <output ref={output} className="collab-perf" aria-label={t('#CollabPerfLabel')} /> : null;
}
